import { createFileRoute } from "@tanstack/react-router";
import { LocationPage, locationHead } from "../components/LocationPage";
import { locatieContent } from "../lib/locatie-content";

export const Route = createFileRoute("/timmerman-sliedrecht")({
  head: () => locationHead(locatieContent.sliedrecht),
  component: () => <LocationPage slug="sliedrecht" />,
});
